import { BenchmarkView } from '../../../../../generated/model/benchmarkView';

export const consolidationToggleState = (
  hasConsolidated: boolean,
  hasUnconsolidated: boolean,
  consolidationPreference?: BenchmarkView.ConsolidationPreferenceEnum,
  toggleValue?: BenchmarkView.ConsolidationPreferenceEnum,
): { showConsolidationToggle: boolean; consolidation: boolean } => {
  const showConsolidationToggle =
    // we show toggle if we have both consolidated and unconsolidated data OR if we use prefer consolidated option
    (consolidationPreference === undefined && hasConsolidated && hasUnconsolidated) ||
    consolidationPreference === 'PREFER_CONSOLIDATED';
  let consolidation = showConsolidationToggle ? toggleValue === 'CONSOLIDATED' : hasConsolidated;
  if (consolidationPreference !== undefined && consolidationPreference !== 'PREFER_CONSOLIDATED') {
    consolidation = consolidationPreference === 'CONSOLIDATED';
  }
  return { showConsolidationToggle, consolidation };
};
